import { Flex, Pill } from "@mantine/core";
import type { JSX } from "react";
import classes from "./TimelineItem.module.css";
import type { MessageTagProps } from "./types";

export function TextMask({ children, isExpanded }: { isExpanded: boolean; children: React.ReactNode }): JSX.Element {
    const className = isExpanded ? classes.textMaskExpanded : classes.textMaskNotExpanded;
    return (
        <Flex className={className} direction="column">
            {children}
        </Flex>
    );
}

export function MessageTag({ tagName }: MessageTagProps): JSX.Element {
    return (
        <Pill
            bg="linear-gradient(90deg, var(--mantine-color-success-4) 0.3%, #60FFFF 105.93%)"
            c="var(--mantine-color-black)"
            fw={700}
            fz="xs"
            mb=".5rem"
            p="0.1875rem"
            radius={2}
            size="xs"
            w="fit-content"
        >
            {tagName}
        </Pill>
    );
}
